module.exports = {"new":"Novinka","unavailable":"Nedostupné","noHistorySubtitle":"záznamů","historySubtitle":"aktivní/vč. historie"}